import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import { api } from '../api/client';

type DatosForm = {
  nombre: string; apellido: string; telefono: string; email: string;
  calle: string; nro_puerta: string; piso_depto: string; entre_calles: string;
};

type Perfil = {
  nombre: string; apellido: string; telefono: string; email: string;
  calle: string; nro_puerta: string; piso_depto: string; entre_calles: string;
};

function Campo({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div>
      <label className="block text-xs font-semibold mb-1.5" style={{ color: '#64748b' }}>
        {label}
      </label>
      {children}
    </div>
  );
}

export default function EditarDatos() {
  const nav = useNavigate();
  const [form,     setForm]     = useState<DatosForm | null>(null);
  const [loading,  setLoading]  = useState(true);
  const [guardando,setGuardando] = useState(false);
  const [err,      setErr]      = useState<string | null>(null);

  useEffect(() => {
    api<Perfil>('/perfil')
      .then((p) => setForm({
        nombre:      p.nombre       || '',
        apellido:    p.apellido     || '',
        telefono:    p.telefono     || '',
        email:       p.email        || '',
        calle:       p.calle        || '',
        nro_puerta:  p.nro_puerta   || '',
        piso_depto:  p.piso_depto   || '',
        entre_calles:p.entre_calles || '',
      }))
      .catch((e) => setErr(e.message))
      .finally(() => setLoading(false));
  }, []);

  function set(k: keyof DatosForm, v: string) {
    setForm((f) => f ? { ...f, [k]: v } : f);
  }

  async function guardar(e: React.FormEvent) {
    e.preventDefault();
    if (!form) return;
    if (!form.nombre.trim()) return setErr('El nombre es obligatorio');
    if (!form.apellido.trim()) return setErr('El apellido es obligatorio');
    setGuardando(true); setErr(null);
    try {
      await api('/perfil?action=datos', {
        method: 'PUT',
        body: JSON.stringify({
          nombre:      form.nombre.trim(),
          apellido:    form.apellido.trim(),
          telefono:    form.telefono.trim()    || null,
          email:       form.email.trim()       || null,
          calle:       form.calle.trim()       || null,
          nro_puerta:  form.nro_puerta.trim()  || null,
          piso_depto:  form.piso_depto.trim()  || null,
          entre_calles:form.entre_calles.trim()|| null,
        }),
      });
      nav('/perfil', { replace: true });
    } catch (ex: any) {
      setErr(ex.message || 'No se pudo guardar');
    } finally {
      setGuardando(false);
    }
  }

  const inp = "w-full rounded-xl px-4 py-3 text-sm outline-none";
  const inpStyle = { backgroundColor: '#ffffff', border: '1px solid #6e6b6b', color: '#303030' };

  return (
    <>
      <TopBar title="Editar datos personales" back />
      <main className="max-w-sm mx-auto px-5 py-6 pb-24 space-y-4">

        {loading && <p className="text-center text-gray-400 text-sm py-6">Cargando…</p>}

        {form && (
          <form onSubmit={guardar} className="space-y-4">

            <div className="grid grid-cols-2 gap-3">
              <Campo label="Nombre *">
                <input type="text" value={form.nombre}
                  onChange={(e) => set('nombre', e.target.value)}
                  className={inp} style={inpStyle} />
              </Campo>
              <Campo label="Apellido *">
                <input type="text" value={form.apellido}
                  onChange={(e) => set('apellido', e.target.value)}
                  className={inp} style={inpStyle} />
              </Campo>
            </div>

            <Campo label="Teléfono">
              <input type="tel" inputMode="numeric" value={form.telefono}
                onChange={(e) => set('telefono', e.target.value)}
                placeholder="Ej: 2993012345"
                className={inp} style={inpStyle} />
            </Campo>

            <Campo label="Email">
              <input type="email" value={form.email}
                onChange={(e) => set('email', e.target.value)}
                placeholder="correo@ejemplo.com"
                className={inp} style={inpStyle} />
            </Campo>

            <div className="grid grid-cols-3 gap-3">
              <div className="col-span-2">
                <Campo label="Calle">
                  <input type="text" value={form.calle}
                    onChange={(e) => set('calle', e.target.value)}
                    className={inp} style={inpStyle} />
                </Campo>
              </div>
              <Campo label="Nro.">
                <input type="text" value={form.nro_puerta}
                  onChange={(e) => set('nro_puerta', e.target.value)}
                  className={inp} style={inpStyle} />
              </Campo>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <Campo label="Piso / Depto">
                <input type="text" value={form.piso_depto}
                  onChange={(e) => set('piso_depto', e.target.value)}
                  placeholder="Ej: 2° B"
                  className={inp} style={inpStyle} />
              </Campo>
              <Campo label="Entre calles">
                <input type="text" value={form.entre_calles}
                  onChange={(e) => set('entre_calles', e.target.value)}
                  className={inp} style={inpStyle} />
              </Campo>
            </div>

            {err && (
              <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl p-3">
                {err}
              </div>
            )}

            <button
              type="submit"
              disabled={guardando}
              className="w-full bg-brand-600 disabled:opacity-50 text-white rounded-xl py-3.5 font-bold text-base"
            >
              {guardando ? 'Guardando…' : 'Guardar cambios'}
            </button>
          </form>
        )}
      </main>
    </>
  );
}
